import './Section.css'
import PropTypes from 'prop-types';

function Section({title, secondaryTitle, body}) {
  return (
    <section className='section'>
        <section className='section-header'>
          <div className='main-title'>{title}</div>
        </section>
        <section className='section-body-wrapper'> 
          <div className='section-body'>
            <div className='secondary-title'>
              {secondaryTitle}
            </div>
            {body}
          </div>
        </section>
      </section>
  );
}

Section.propTypes = {
  title: PropTypes.string,
  body: PropTypes.node,
  secondaryTitle: PropTypes.node
};

export default Section;